/* ==========================================================================
   MATTCH — rodape do carrinho
   Monta: rotulo "Subtotal", parcelamento em 3x, linha de frete gratis, o
   valor no botao de finalizar e o link "continuar comprando". Tambem
   reescreve o valor do subtotal sem o codigo de moeda (BRL).

   Trabalha por fora do cart-summary.liquid de proposito, para nao brigar com
   o script que clona o botao da Yampi lendo textContent.
   ========================================================================== */
(function () {
  var PARCELAS = 3;
  var ROTULO_BOTAO = 'Finalizar pedido';
  var ROTULO_SUBTOTAL = 'Subtotal';
  var ROTULO_FRETE = 'Frete';
  var VALOR_FRETE = 'Grátis';

  var MOEDA = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  // "R$ 1.234,56 BRL" -> 1234.56
  function lerMoeda(texto) {
    if (!texto) return NaN;
    var s = String(texto).replace(/[^0-9.,-]/g, '').trim();
    if (!s) return NaN;
    s = s.replace(/\./g, '').replace(',', '.');
    return parseFloat(s);
  }

  function montar() {
    var totais = document.querySelector('.cart-totals__container');
    if (!totais) return;

    var elValor = document.querySelector('[data-cart-subtotal]')
      || totais.querySelector('.cart-totals__total-value');
    var total = elValor ? lerMoeda(elValor.textContent) : NaN;

    // 1. rotulo do subtotal
    var label = totais.querySelector('.cart-totals__total-label');
    if (label && label.textContent.trim() !== ROTULO_SUBTOTAL) {
      label.textContent = ROTULO_SUBTOTAL;
    }

    // 2. valor do subtotal sem o codigo de moeda.
    // reescrever com o mesmo formato que lemos mantem a operacao idempotente.
    if (elValor && isFinite(total)) {
      var limpo = MOEDA.format(total);
      if (elValor.textContent.trim() !== limpo) {
        elValor.textContent = limpo;
      }
      if (elValor.getAttribute('value') !== null && elValor.getAttribute('value') !== limpo) {
        elValor.setAttribute('value', limpo);
      }
    }

    // 3. parcelamento
    var parcelas = totais.querySelector('[data-mt-parcelas]');
    if (!parcelas) {
      parcelas = document.createElement('span');
      parcelas.className = 'mt-parcelas';
      parcelas.setAttribute('data-mt-parcelas', '');
      var linhaTotal = totais.querySelector('.cart-totals__total');
      if (linhaTotal) linhaTotal.insertAdjacentElement('afterend', parcelas);
      else totais.appendChild(parcelas);
    }
    var textoParcelas = '';
    if (isFinite(total) && total > 0) {
      textoParcelas = 'ou ' + PARCELAS + 'x de ' + MOEDA.format(total / PARCELAS) + ' sem juros';
    }
    if (parcelas.textContent !== textoParcelas) parcelas.textContent = textoParcelas;

    // 4. frete
    if (!totais.querySelector('[data-mt-frete]')) {
      var frete = document.createElement('div');
      frete.className = 'mt-frete';
      frete.setAttribute('data-mt-frete', '');

      var fLabel = document.createElement('span');
      fLabel.className = 'mt-frete__label';
      fLabel.textContent = ROTULO_FRETE;

      var fValor = document.createElement('span');
      fValor.className = 'mt-frete__valor';
      fValor.textContent = VALOR_FRETE;

      frete.appendChild(fLabel);
      frete.appendChild(fValor);
      parcelas.insertAdjacentElement('afterend', frete);
    }

    // 5. botao: rotulo a esquerda, valor a direita.
    // o valor vai num atributo e e desenhado pelo ::after do CSS: assim ele
    // nao entra no textContent que o script da Yampi le para clonar o botao.
    var botoes = document.querySelectorAll('.cart__checkout-button, .ymp_elem_mainBtn');
    for (var i = 0; i < botoes.length; i++) {
      var b = botoes[i];
      b.classList.add('mt-btn-duplo');

      if (isFinite(total) && total > 0) {
        var valorBotao = MOEDA.format(total);
        if (b.getAttribute('data-mt-total') !== valorBotao) {
          b.setAttribute('data-mt-total', valorBotao);
        }
      } else if (b.hasAttribute('data-mt-total')) {
        b.removeAttribute('data-mt-total');
      }

      var texto = b.querySelector('.button-text');
      if (texto && texto.textContent.trim() !== ROTULO_BOTAO) {
        texto.textContent = ROTULO_BOTAO;
      }
    }

    // 6. continuar comprando
    var ctas = document.querySelector('.cart__ctas');
    if (ctas && !ctas.querySelector('[data-mt-continuar]')) {
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'mt-continuar';
      link.setAttribute('data-mt-continuar', '');
      link.textContent = 'continuar comprando';
      link.addEventListener('click', function () {
        var fechar = document.querySelector('.cart-drawer__close-button');
        if (fechar) fechar.click();
        else window.location.href = '/collections/all';
      });
      ctas.appendChild(link);
    }
  }

  var agendado = null;
  function agendar() {
    if (agendado) return;
    agendado = setTimeout(function () {
      agendado = null;
      montar();
    }, 120);
  }

  function iniciar() {
    montar();
    new MutationObserver(agendar).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.addEventListener('dialog:open', agendar);
    document.addEventListener('cart:updated', agendar);
    document.addEventListener('cart:item-added', agendar);
    [300, 900, 2000].forEach(function (ms) { setTimeout(montar, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
